import { agreementSelectors } from 'agreement/redux/agreementsReducer';
import { MESSAGING } from 'core/datasets/action';
import { IChannelFromBE } from 'messaging/types/messages';
import generateChannelsMap from 'messaging/utils/messagingUtils';
import { select, put } from 'redux-saga/effects';

export function* parseChannelsMap(action: {
    type: typeof MESSAGING.FETCHED_NEW_CHANNELS_MAP;
    payload: {
        data: {
            messagingChannelListBySaasEnvironment: IChannelFromBE[];
        };
    };
}): Generator {
    const { data } = action.payload;
    if (!data || !data.messagingChannelListBySaasEnvironment) {
        return;
    }

    const channelsMap = generateChannelsMap(data.messagingChannelListBySaasEnvironment);
    const selectedAgreementId = yield select(agreementSelectors.selectedAgreementId);
    yield put({
        type: MESSAGING.SET_CHANNELS_MAP,
        payload: { channelsMap, selectedAgreementId },
    });
}
